import { ReactNode } from 'react';

interface TooltipProps {
  text: string | ReactNode;
  children?: ReactNode;
}

/**
 * Simple hover tooltip using CSS
 * Displays an info icon that shows tooltip on hover
 */
export function Tooltip({ text, children }: TooltipProps) {
  return (
    <div className="relative group inline-flex items-center">
      {children || (
        <span className="text-gray-500 hover:text-gray-300 cursor-help text-sm ml-1">
          &#9432;
        </span>
      )}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg shadow-lg text-xs text-gray-300 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 pointer-events-none">
        {text}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-gray-700" />
      </div>
    </div>
  );
}
